import { useMutation } from '@tanstack/react-query';
import { deleteChatArtifact } from '../lib/api/chatArtifactApi.connect';
/**
 * Soft-delete a chat artifact (all versions) over Connect (sabaody -> tesoro).
 *
 * Ownership is enforced server-side against the stored row, so a caller can only
 * delete their own — a denied delete surfaces as a rejected mutation. The
 * Artifacts list is a plain hook rather than a react-query cache, so callers
 * refetch it themselves on success rather than relying on query invalidation.
 */ export const useDeleteDocument = ()=>useMutation({
        mutationFn: (documentId)=>deleteChatArtifact(documentId)
    });
